module.exports = __webpack_public_path__ + "ae.no2.675ba01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ae.no2.jpg
// module id = vhLa
// module chunks = 0